import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


interface Droit {
  titre: string;
  description: string;
}


@Component({
  selector: 'app-consentement',
  templateUrl: './consentement.component.html',
  styleUrls: ['./consentement.component.css']
})
export class ConsentementComponent implements OnInit {

  form: FormGroup;
  submitting = false;
  currentPage = 1;


  donneesCollectees: string[] = [
    'Nom, âge et sexe',
    'Coordonnées de la personne à contacter',
    'Modalités de participation au programme',
    "Niveau d'éducation",
    'État civil',
    'Statut de réfugié ou de personne déplacée',
    "Présence d'un handicap",
    "Retour d'information et réponses aux enquêtes"
  ];

  vosDroits: Droit[] = [
    { titre: "Droit d'accès :", description: 'Vous avez le droit de demander une copie des informations que nous détenons à votre sujet.' },
    { titre: 'Droit de rectification :', description: 'Vous avez le droit de nous demander de corriger toute information inexacte que nous détenons à votre sujet.' },
    { titre: "Droit à l'effacement :", description: "Vous avez le droit de nous demander d'effacer vos informations." },
    { titre: 'Droit à la limitation du traitement :', description: 'Vous avez le droit de nous demander de restreindre le traitement de vos informations.' },
    { titre: "Droit d'opposition au traitement :", description: "Vous avez le droit de vous opposer au traitement de vos informations." },
    { titre: 'Droit à la portabilité des données :', description: 'Vous avez le droit de demander que vos données soient transférées à une autre organisation.' }
  ];
  ngOnInit(): void {

  }

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      accepte: [false, Validators.requiredTrue]
    });
  }

  goToPage(page: 1 | 2): void {
    this.currentPage = page;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.submitting = true;
    console.log('Consentement soumis :', this.form.value);
    this.submitting = false;
  }
}
